<template>
  <b-col sm="12" :lg="lgSize">
    <div class="animated fadeIn">
      <b-card class="backClass" header="Received">
        <div
          slot="header"
          style="display:flex; justify-content: space-between;"
        >
          <HeaderTitle title="Active Backlog"></HeaderTitle>
          <HeaderControl
            :showFullscreenIcon="true"
            :showDownloadPdfIcon="true"
            @emit-fullscreen="toggleFullScreen"
            @emit-pdf-download="downloadPDF"
          ></HeaderControl>
        </div>
        <div style="margin-top: 30px" class="chart-wrapper">
          <LoadingCard v-if="loadingData"></LoadingCard>
          <highcharts
            ref="backRef"
            v-else
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../../router";
import Highcharts from "highcharts";
import exporting from "highcharts/modules/exporting";
import HeaderTitle from "../shared/HeaderTitle.vue";
import HeaderControl from "../shared/HeaderControl.vue";
import LoadingCard from "../shared/LoadingCard.vue";
import { ModelActiveBacklogChart } from "../../utils/ChartProps";
exporting(Highcharts);

export default {
  name: "ActiveBacklogModel",
  components: {
    router,
    highcharts: Chart,
    Highcharts,
    HeaderTitle,
    HeaderControl,
    LoadingCard
  },
  props: ["lgSize", "part", "modelData"],
  data: function() {
    return {
      fullscreen: false,
      loadingData: false,
      showAll: false,
      chartOptions: {}
    };
  },
  methods: {
    exitFullscreen() {
      if (!this.fullscreen) {
        return;
      } else {
        this.toggleFullScreen();
      }
    },
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".backClass"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    fetchData() {
      this.loadingData = true;
      let params = {};
      params = {
        chartType: "backlog",
        model: this.part
      };
      this.$http.get("api/charts/chart_product.php", { params }).then(
        res => {
          if (!this.showAll) {
            let tmp = res.data.upData;
            tmp.sort((a, b) =>
              parseFloat(a.locationTotal) > parseFloat(b.locationTotal) ? -1 : 1
            );

            let smp = res.data.dnData;

            smp.forEach(value => {
              value.data.sort((a, b) =>
                parseInt(a[1]) > parseInt(b[1]) ? -1 : 1
              );
            });

            let newArr = tmp.slice(0, 10);

            if (smp.length != 0) {
              this.chartOptions.series[0].data = newArr;
            }
          } else {
            let smp = res.data.dnData;

            smp.forEach(value => {
              value.data.sort((a, b) =>
                parseInt(a[1]) > parseInt(b[1]) ? -1 : 1
              );
            });
            let tmp = res.data.upData;
            tmp.sort((a, b) =>
              parseFloat(a.locationTotal) > parseFloat(b.locationTotal) ? -1 : 1
            );

            this.chartOptions.series[0].data = smp[0].data;
          }

          this.chartOptions.title.text = "Total units: " + res.data.totals;
          this.loadingData = false;
          setTimeout(() => {
            this.changeHeight();
          });
        },
        err => {
          this.loadingData = false;
          console.log(err);
        }
      );
    },
    changeHeight() {
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    downloadPDF() {
      this.$refs.backRef.chart.options.title.text = "Active Backlog";
      this.$refs.backRef.chart.options.title.style.color = "black";

      this.$refs.backRef.chart.options.title.style.display = "block";
      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "black";

      this.$refs.backRef.chart.options.xAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });

      this.$refs.backRef.chart.exportChart({
        type: "application/pdf",
        filename: "ActiveBacklog"
      });

      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "white";
    }
  },

  created() {
    this.chartOptions = ModelActiveBacklogChart(router, this.modelData);
    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.highcharts-exporting-group {
  display: none !important;
}
</style>
